import userInfoTypes from '../types/userActionTypes';
import paymentTypes from '../types/paymentType';
import setToken from '../../config/axios';
import { setTokenInCookie, clearTokenInCookie } from '../../Utilities/CookieHandler';
import { initiateAppData } from "../SeedStore";
import userService from "../../services/user.service";
import paymentService from "../../services/payment.service";
import driverActionTypes from '../types/driverActionTypes';
import driversService from '../../services/drivers.service';
import tagActionTypes from '../types/tagActionTypes';
import tagsService from '../../services/tags.service';
import invoiceActionTypes from '../types/invoiceActionTypes';
import invoicesService from '../../services/invoices.service';
import { getFirstDateOfMonth, formatTimeToServerFormat, getLastDayOfMonth } from '../../Utilities/TimeHelper'
import { openInAppBrowser } from '../../platform/inAppBrowser';

// User info 

export const register = (data) => async (dispatch) => {
    try {
        dispatch({
            type: userInfoTypes.START_REGISTER
        });
        const response = await userService.register(data);

        const token = response.data.payload;
        setToken(token)
        setTokenInCookie(token)
        dispatch({
            type: userInfoTypes.REGISTE_SUCCESS,
            payload: response.data.token,
        });
        await dispatch(initiateAppData());
    } catch (error) {
        dispatch({
            type: userInfoTypes.REGISTE_FAILURE,
            payload: error.response?.data?.error,
        });
    }
};

export const login = (userCredenatials) => async (dispatch) => {
    try {
        dispatch({
            type: userInfoTypes.START_LOGIN,
        });
        const response = await userService.login(userCredenatials);

        const token = response.data.payload.message;
        setToken(token)
        setTokenInCookie(token)
        await dispatch(setIsOPU());

        dispatch({
            type: userInfoTypes.LOGIN_SUCCESS,
            payload: response.data.token,
        });
        await dispatch(initiateAppData());

    } catch (error) {
        dispatch({
            type: userInfoTypes.LOGIN_FAILURE,
            payload: error.response?.data?.error,
        });
    }

};

export const logout = () => (dispatch) => {
    clearTokenInCookie()
    dispatch({
        type: userInfoTypes.LOGOUT,
    });
}

export const autoLogin = (token) => {
    setToken(token)
    return {
        type: userInfoTypes.AUTO_LOGIN,
        payload: token
    }
}

export const updateUser = (user) => async (dispatch) => {
    try {
        dispatch({
            type: userInfoTypes.START_UPDATE_USER,
        });
        var response = await userService.updateUser(user);
        dispatch({
            type: userInfoTypes.UPDATE_USER_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: userInfoTypes.UPDATE_USER_FAILUR,
            payload: error.response,
        });
    }
};

export const setIsOPU = () => async (dispatch) => {
    try {
        var response = await userService.isOPU();
        dispatch({
            type: userInfoTypes.SET_IS_OPU_SUCCESS,
            payload: response.data.payload,
        });
        return response.payload
    } catch (error) {
        dispatch({
            type: userInfoTypes.SET_IS_OPU_FAILURE,
            payload: error.response,
        });
        console.error(error)
    }
};

export const getUserDetails = () => async (dispatch) => {
    try {
        dispatch({ type: userInfoTypes.START_GET_USER_DETAILS });

        var response = await userService.getUserDetails();

        dispatch({
            type: userInfoTypes.GET_USER_DETAILS_SUCCESS,
            payload: response.data,
        });
        return response.payload
    } catch (error) {
        dispatch({
            type: userInfoTypes.GET_USER_DETAILS_FAILURE,
            payload: error.response,
        });
        console.error(error)
    }
};

export const resetStateInfo = () => (dispatch) => {
    dispatch({ type: userInfoTypes.RESET_STATE_INFO });
};

// Self-service account deletion (spec 000001 + 000003 Round A follow-up). Calls the BFF pass-through and
// returns a normalized result so the UI can show blocker/error messaging. The local session MUST be cleared
// whenever the account has actually been closed — signalled by result === 'Succeeded' OR the structured
// teardownCommitted flag. teardownCommitted === true means the Main-DB teardown + identity release already
// COMMITTED even if a post-commit LocalAuthList side effect failed (Result stays 'Failed' + HTTP 500 → axios
// rejects → the CATCH branch), so the user's token is stale and must not survive. We NEVER parse the message
// text. Field access is case-tolerant (result/Result, teardownCommitted/TeardownCommitted) across the BFF hop.
export const deleteAccount = () => async (dispatch) => {
    try {
        dispatch({ type: userInfoTypes.START_DELETE_ACCOUNT });
        const response = await userService.deleteAccount();
        const data = response?.data || {};
        const result = data.result ?? data.Result;
        const teardownCommitted = (data.teardownCommitted ?? data.TeardownCommitted) === true;

        dispatch({ type: userInfoTypes.DELETE_ACCOUNT_SUCCESS, payload: data });

        // Clear the session once the account is closed: Succeeded, or teardown committed on a non-2xx that
        // still reached this branch. (A pure Succeeded is HTTP 200; teardownCommitted covers any 2xx variant.)
        if (result === 'Succeeded' || teardownCommitted) {
            dispatch(logout());
        }
        return { ok: true, result, teardownCommitted, data };
    } catch (error) {
        // 404/501/409/5xx land here (axios rejects non-2xx). A Failed response can still carry
        // teardownCommitted === true (post-commit LAL failure) — the account IS closed, so log the user out.
        const data = error?.response?.data || {};
        const result = data.result ?? data.Result;
        const teardownCommitted = (data.teardownCommitted ?? data.TeardownCommitted) === true;

        dispatch({ type: userInfoTypes.DELETE_ACCOUNT_FAILURE, payload: data });

        if (result === 'Succeeded' || teardownCommitted) {
            dispatch(logout());
        }
        return {
            ok: false,
            result,
            teardownCommitted,
            blockerReasons: data.blockerReasons ?? data.BlockerReasons,
            message: data.message ?? data.Message,
            status: error?.response?.status,
            data,
        };
    }
};

export const forgotPassword = (email) => async (dispatch) => {
    try {
        dispatch({
            type: userInfoTypes.START_FORGOTE_PASSWORD,
        });
        var response = await userService.forgotPassword(email);
        dispatch({
            type: userInfoTypes.FORGOTE_PASSWORD_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: userInfoTypes.FORGOTE_PASSWORD_FAILURE,
            payload: error.response,
        });
    }
};

export const resetPassword = (userCredenatials) => async (dispatch) => {
    try {
        dispatch({
            type: userInfoTypes.START_RESET_PASSWORD,
        });
        var response = await userService.resetPassword(userCredenatials);

        // Check the status of the response
        if (response.status >= 200 && response.status < 300) {
            // Successful response status
            dispatch({
                type: userInfoTypes.RESET_PASSWORD_SUCCESS,
            });
        } else {
            // Unsuccessful response status
            dispatch({
                type: userInfoTypes.RESET_PASSWORD_FAILURE,
                payload: new Error(`Server responded with status: ${response.status}`),
            });
        }
    } catch (error) {
        dispatch({
            type: userInfoTypes.RESET_PASSWORD_FAILURE,
            payload: error,
        });
    }
};

// Payment info
export const getUserPayment = () => async (dispatch) => {

    try {
        dispatch({
            type: paymentTypes.START_GET_USER_PAYMENT,
        })
        var response = await paymentService.getUserPayment();

        dispatch({
            type: paymentTypes.GET_USER_PAYMENT_SUCCESS,
            payload: response.data,
        })
    } catch (error) {
        dispatch({
            type: paymentTypes.GET_USER_PAYMENT_FAILURE,
            payload: error,
        });
        console.error(error)
    }
};

export const createPaymentToken = () => async (dispatch) => {
    try {
        dispatch({
            type: paymentTypes.START_CREATE_PAYMENT_TOKEN,
        })

        var response = await paymentService.createPaymentToken();

        dispatch({
            type: paymentTypes.CREATE_PAYMENT_TOKEN_SUCCESS,
            payload: response.data,
        })
    } catch (error) {
        dispatch({
            type: paymentTypes.CREATE_PAYMENT_TOKEN_FAILURE,
            payload: error,
        });
        console.error(error)
    }
};

export const setUserPayment = (value) => async (dispatch) => {
    try {
        dispatch({
            type: paymentTypes.START_CREATE_USER_PAYMENT,
        })
        var response = await paymentService.setUserPayment(value);


        dispatch({
            type: paymentTypes.CREATE_USER_PAYMENT_SUCCESS,
            payload: response.data,
        })
    } catch (error) {
        dispatch({
            type: paymentTypes.CREATE_USER_PAYMENT_FAILURE,
            payload: error,
        });
        console.error(error)
    }
};

export const deleteUserPayment = () => async (dispatch) => {
    try {
        dispatch({
            type: paymentTypes.START_DELETE_USER_PAYMENT,
        })
        var response = await paymentService.deleteUserPayment();
        dispatch({
            type: paymentTypes.DELETE_USER_PAYMENT_SUCCESS,
            payload: response.data,
        })
        dispatch(getUserPayment());
    } catch (error) {
        dispatch({
            type: paymentTypes.DELETE_USER_PAYMENT_FAILURE,
            payload: error?.response?.data?.error,
        });
        console.error(error)
    }
};

// ************ Yaad Sarig ************ 
export const createPaymentLandingPage = (value) => async (dispatch) => {
    try {
        dispatch({
            type: paymentTypes.START_CREATE_PAYMENT_LANDING_PAGE,
        })
        var response = await paymentService.createPaymentLandingPage(value);

        const url = response?.data?.payload?.url;
        if (url) {
            // Native: opens an in-app WebView (needed to intercept the Yaad Sarig /
            // CreditGuard return - platform/deepLink.js). Web: window.location.assign.
            await openInAppBrowser(url);
        }

        dispatch({
            type: paymentTypes.CREATE_PAYMENT_LANDING_PAGE_SUCCESS,
            payload: response.data,
        })
    } catch (error) {
        dispatch({
            type: paymentTypes.CREATE_PAYMENT_LANDING_PAGE_FAILURE,
            payload: error,
        });
        console.error(error)
    }
};

// ************ CreditGuard (spec 000141) ************
export const createTokenFromCreditGuardRedirect = (data) => async (dispatch) => {
    try {
        dispatch({
            type: paymentTypes.START_CREATE_USER_PAYMENT,
        })
        var response = await paymentService.createTokenFromCreditGuardRedirect(data);
        dispatch({
            type: paymentTypes.CREATE_USER_PAYMENT_SUCCESS,
            payload: response.data,
        })
    } catch (error) {
        dispatch({
            type: paymentTypes.CREATE_USER_PAYMENT_FAILURE,
            payload: error,
        });
        console.error(error)
    }
};

export const createTokenFromTransaction = (data) => async (dispatch) => {
    try {
        dispatch({
            type: paymentTypes.START_CREATE_USER_PAYMENT,
        })
        var response = await paymentService.createTokenFromTransaction(data);
        dispatch({
            type: paymentTypes.CREATE_USER_PAYMENT_SUCCESS,
            payload: response.data,
        })
    } catch (error) {
        dispatch({
            type: paymentTypes.CREATE_USER_PAYMENT_FAILURE,
            payload: error,
        });
        console.error(error)
    }
};
// ************ ************ ************ ************ ************ ************

// Drivers info
export const getDrivers = () => async (dispatch) => {
    try {
        dispatch({
            type: driverActionTypes.START_GET_DRIVERS_LIST
        })
        var response = await driversService.getDrivers();
        dispatch({
            type: driverActionTypes.GET_DRIVERS_LIST_SUCCESS,
            payload: response.data,
        })
    } catch (error) {
        dispatch({
            type: driverActionTypes.GET_DRIVERS_LIST_FAILURE,
            payload: error,
        });
        console.error(error)
    }
}

export const addDriver = (driverDetails) => async (dispatch) => {
    try {
        dispatch({
            type: driverActionTypes.START_ADD_DRIVER
        })
        var response = await driversService.addDriver(driverDetails);
        dispatch({
            type: driverActionTypes.ADD_DRIVER_SUCCESS,
            payload: response,
        })
    } catch (error) {
        dispatch({
            type: driverActionTypes.ADD_DRIVER_FAILURE,
            payload: error,
        });
        console.error(error)
    }
}

export const editDriver = (driverDetails) => async (dispatch) => {
    try {
        dispatch({
            type: driverActionTypes.START_EDIT_DRIVER
        })

        var response = await driversService.editDriver(driverDetails);
        dispatch({
            type: driverActionTypes.EDIT_DRIVER_SUCCESS,
            payload: response.data,
        })
    } catch (error) {
        dispatch({
            type: driverActionTypes.EDIT_DRIVER_FAILURE,
            payload: error,
        });
        console.error(error)
    }
}

export const deleteDriver = (id) => async (dispatch) => {
    try {
        dispatch({
            type: driverActionTypes.START_DELETE_DRIVER
        })
        var response = await driversService.deleteDriver(id);
        dispatch({
            type: driverActionTypes.DELETE_DRIVER_SUCCESS,
            payload: response.data,
        })
    } catch (error) {
        dispatch({
            type: driverActionTypes.DELETE_DRIVER_FAILURE,
            payload: error,
        });
        console.error(error)
    }
}

export const editPermissions = (permissions) => async (dispatch) => {
    try {
        dispatch({
            type: driverActionTypes.START_EDIT_PERMISSIONS
        })
        var response = await driversService.editPermissions(permissions);
        dispatch({
            type: driverActionTypes.EDIT_PERMISSIONS_SUCCESS,
            payload: response.data,
        })
    } catch (error) {
        dispatch({
            type: driverActionTypes.EDIT_PERMISSIONS_FAILURE,
            payload: error,
        });
        console.error(error)
    }
}

// Tags info
export const getTags = () => async (dispatch) => {
    try {
        dispatch({
            type: tagActionTypes.START_GET_TAGS_LIST
        })
        var response = await tagsService.getTags();
        dispatch({
            type: tagActionTypes.GET_TAGS_LIST_SUCCESS,
            payload: response.data,
        })
    } catch (error) {
        dispatch({
            type: tagActionTypes.GET_TAGS_LIST_FAILURE,
            payload: error,
        });
        console.error(error)
    }
}

export const addTag = (tagDetails) => async (dispatch) => {
    try {
        dispatch({
            type: tagActionTypes.START_ADD_TAG
        })
        var response = await tagsService.addTag(tagDetails);
        dispatch({
            type: tagActionTypes.ADD_TAG_SUCCESS,
            payload: response.data,
        })
    } catch (error) {
        dispatch({
            type: tagActionTypes.ADD_TAG_FAILURE,
            payload: error,
        });
        console.error(error)
    }
}

export const editTag = (tagDetails) => async (dispatch) => {
    try {
        dispatch({
            type: tagActionTypes.START_EDIT_TAG
        })
        var response = await tagsService.addTag(tagDetails);
        dispatch({
            type: tagActionTypes.EDIT_TAG_SUCCESS,
            payload: response.data,
        })
    } catch (error) {
        dispatch({
            type: tagActionTypes.EDIT_TAG_FAILURE,
            payload: error,
        });
        console.error(error)
    }
}

export const deleteTag = (tagId) => async (dispatch) => {
    try {
        dispatch({
            type: tagActionTypes.START_DELETE_TAG
        })
        var response = await tagsService.deleteTag(tagId);
        dispatch({
            type: tagActionTypes.DELETE_TAG_SUCCESS,
            payload: response.data,
        })
    } catch (error) {
        dispatch({
            type: tagActionTypes.DELETE_TAG_FAILURE,
            payload: error,
        });
        console.error(error)
    }
}

// Invoices info
export const getInvoices = (filterData) => async (dispatch) => {
    try {
        dispatch({
            type: invoiceActionTypes.START_GET_INVOICES_LIST
        })

        if (!filterData) {
            filterData = { startPage: 1, endPage: 1000, startDate: getFirstDateOfMonth(), endDate: formatTimeToServerFormat(new Date()) }
        }
        else {
            filterData = { ...filterData, startPage: 1, endPage: 1000 };
        }

        var response = await invoicesService.getInvoices(filterData);

        dispatch({
            type: invoiceActionTypes.GET_INVOICES_LIST_SUCCESS,
            payload: response.data.payload,
        })
    } catch (error) {
        dispatch({
            type: invoiceActionTypes.GET_INVOICES_LIST_FAILURE,
            payload: error,
        });
        console.error(error)
    }
}

export const getInvoicesSummary = (filterData) => async (dispatch) => {
    try {
        dispatch({
            type: invoiceActionTypes.START_GET_INVOICES_SUMMARY_LIST
        })

        if (!filterData) {
            filterData = { startPage: 1, endPage: 1000, startDate: getFirstDateOfMonth(), endDate: formatTimeToServerFormat(getLastDayOfMonth()) }
        }
        else {
            filterData = { ...filterData, startPage: 1, endPage: 1000, startDate: formatTimeToServerFormat(filterData.startDate) };
        }

        var response = await invoicesService.getInvoicesSummary(filterData);

        dispatch({
            type: invoiceActionTypes.GET_INVOICES_LIST_SUMMARY_SUCCESS,
            payload: response.data.payload,
        })
    } catch (error) {
        dispatch({
            type: invoiceActionTypes.GET_INVOICES_LIST_SUMMARY_FAILURE,
            payload: error,
        });
        console.error(error)
    }
}

export const exporyCahrgingSummaryFile = (langCode, filterData) => async (dispatch) => {
    let response;
    try {
        dispatch({ type: invoiceActionTypes.START_EXPORT_CAHRGING_SUMMARY_FILE });
        response = await invoicesService.exporyCahrgingSummaryFile(langCode, filterData)

        dispatch({
            type: invoiceActionTypes.GET_EXPORT_CAHRGING_SUMMARY_FILE_SUCCESS,
            payload: response.data.payload,
        });
    }
    catch (error) {
        dispatch({
            type: invoiceActionTypes.GET_EXPORT_CAHRGING_SUMMARY_FILE_FAILURE,
        });
    }
    return response;
}

const userInfoActions = {
    // user
    getUserDetails,
    setIsOPU,
    login,
    register,
    updateUser,
    logout,
    autoLogin,
    forgotPassword,
    resetPassword,
    deleteAccount,
    // payment
    getUserPayment,
    createPaymentToken,
    setUserPayment,
    // yaad
    createPaymentLandingPage,
    createTokenFromTransaction,
    // creditguard (spec 000141)
    createTokenFromCreditGuardRedirect,


    deleteUserPayment,
    // druvers
    getDrivers,
    addDriver,
    editDriver,
    deleteDriver,
    editPermissions,
    // tags
    getTags,
    addTag,
    editTag,
    deleteTag,
    // invoices
    getInvoices,
    getInvoicesSummary,
    exporyCahrgingSummaryFile,

    // state
    resetStateInfo
};

export default userInfoActions;

